import { ParallaxBackground } from "@/ui/ParallaxBackground";
import cn from "classnames";
import { Col, Container, Row } from "react-bootstrap";
import { Quote } from "@/ui/Quote";
import { Parallax } from "react-scroll-parallax";
import bg_1 from "./bg_1.webp";
import bg_2 from "./bg_2.webp";
import QuoteMarkStartIcon from "./QuoteMarkStart.svg";
import classes from "./styles.module.scss";

export default function ({ className = "py-6 py-md-7", quote, cite, role, image, EditableImage, EditableText }) {
  return (
    <div className={cn(className, classes.BlockQuote)}>
      <ParallaxBackground anim="y1:x0:z0" image={bg_1} floating={false} className={classes.bg_1} />
      <ParallaxBackground anim="y1:x0:z0" image={bg_2} floating={false} className={classes.bg_2} />
      <Container>
        <Row>
          <Col xs={12} lg={6}>
            <blockquote className="ps-5">
              <img className="svg" src={QuoteMarkStartIcon} alt="" />
              <Quote as={EditableText} path="BlockQuote">
              <div className="mb-4" dangerouslySetInnerHTML={{ __html: quote }} />
              <cite>
                {cite} <br />
                <span>{role}</span>
              </cite>
              </Quote>
           
            </blockquote>
          </Col>
          <Col xs={12} lg={6}>
            <Parallax translateY={[-20, 20]} className={classes.img}>
              <EditableImage path="image" src={image} size="372x319" alt="" />
            </Parallax>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
